// eslint-disable-next-line
import React from 'react';
import { Flex, Box, theme, Radio } from '@xometry/xometry_loft';

const BankAccountMethods = (props) => {
  const { newPaymentMethod, setNewPaymentMethod } = props;

  return (
    <Box>
      <Flex alignItems="flex-start" justifyContent="flex-start">
        <Radio
          checked={newPaymentMethod === 'plaid'}
          onChange={() => setNewPaymentMethod('plaid')}
          enterKeyHint="enter"
        />
        <Box marginLeft="9px">
          <Flex
            color={theme.colors.darkBlues[100]}
            fontSize={theme.fontSizes[2]}
            fontWeight={theme.fontWeights.semibold}
            lineHeight={theme.lineHeights[3]}
          >
            <Box marginRight={theme.space[1]}>Instant Verification</Box>
            <Box
              fontWeight={theme.fontWeights.regular}
              color={theme.colors.darkBlues[75]}
            >
              Via Plaid
            </Box>
          </Flex>
          <Box
            color={theme.colors.darkBlues[90]}
            fontSize={theme.fontSizes[0]}
            lineHeight={theme.lineHeights[2]}
          >
            Login with your bank credentials directly. Works with most banks
            instantly.
          </Box>
        </Box>
      </Flex>
      {/*
      <Box
        margin="12px 0px"
        height="1px"
        backgroundColor={theme.colors.blues[5]}
      />
      <Flex alignItems="flex-start" justifyContent="flex-start">
        <Radio
          checked={newPaymentMethod === "microDeposit"}
          onChange={() => setNewPaymentMethod("microDeposit")}
          enterKeyHint="enter"
        />
        <Box marginLeft="9px">
          <Box
            color={theme.colors.darkBlues[100]}
            fontSize={theme.fontSizes[2]}
            fontWeight={theme.fontWeights.semibold}
            lineHeight={theme.lineHeights[3]}
          >
            Tradition Verification
          </Box>
          <Box
            color={theme.colors.darkBlues[90]}
            fontSize={theme.fontSizes[0]}
            lineHeight={theme.lineHeights[2]}
          >
            Confirm two small deposits to your bank account. Takes approx. 1-2
            business days.
          </Box>
        </Box>
      </Flex>
      */}
    </Box>
  );
};

export default BankAccountMethods;
